  import api from "./axiosConfig"; // Importa la configuración centralizada de axios

  // (2026-05-19) Normalizador de COMPATIBILIDAD del shape de Retención tras
  // el rename de modelos. El backend agrupa: sujeto_retenido:{} (antes
  // planos sujeto_retenido_nombre/rif) y entrega el emisor directamente en
  // `empresa:{}` + `empresa_id` y la afiliada en `tercero:{}`. Sólo se
  // re-exponen los planos sujeto_retenido_* para consumidores legacy.
  const _compatRetencion = (r) => {
    if (!r || typeof r !== "object") return r;
    const sr = r.sujeto_retenido;
    if (sr && typeof sr === "object") {
      if (r.sujeto_retenido_nombre == null) r.sujeto_retenido_nombre = sr.nombre;
      if (r.sujeto_retenido_rif == null) r.sujeto_retenido_rif = sr.rif;
    }
    return r;
  };

  const _compatRetencionResp = (data) => {
    try {
      if (Array.isArray(data)) { data.forEach(_compatRetencion); return data; }
      if (data && Array.isArray(data.data)) { data.data.forEach(_compatRetencion); return data; }
      if (data && Array.isArray(data.resultados)) { data.resultados.forEach(_compatRetencion); return data; }
    } catch (_e) { /* noop */ }
    return data;
  };

  // Obtener todas retenciones
  export const getAllWithholdings = async (params = {}) => {
    try {
      const authData = localStorage.getItem("authData");
      const {
        page = 1,
        per_page = 20,
        numero_comprobante,
        sujeto_retenido_rif,
        periodo_fiscal,
      } = params;

      if (!authData) return;

      const { rol } = JSON.parse(authData);

      const endpoint = '/api/retenciones/';

      const query = new URLSearchParams({
        page,
        per_page,
        ...(numero_comprobante && { numero_comprobante }),
        ...(sujeto_retenido_rif && { sujeto_retenido_rif }),
        ...(periodo_fiscal && { periodo_fiscal }),
      });

      const response = await api.get(`${endpoint}?${query.toString()}`);
      return _compatRetencionResp(response.data);
    } catch (error) {
      console.error("Error al obtener las retenciones:", error);
      throw error;
    }
  };

  // Consultar una retencion por comprobante ID
  export const showWithholding = async (id) => {
    try {
      const authData = localStorage.getItem("authData");
      if (authData) {
        const { rol } = JSON.parse(authData);
        var response;
        response = await api.get(`/api/retenciones/${id}`);
        return _compatRetencion(response.data);
      }
    } catch (error) {
      console.error("Error al consultar la retencion:", error);
      throw error;
    }
  };

  // Crear una retencion
  export const createWithholding = async (body) => {
    try {
      const response = await api.post(`/api/retenciones/`, body);
      console.log('createWithholding-response: ', response);
      return response.data;
    } catch (error) {
      console.error("Error al crear la retencion:", error);
      throw error;
    }
  };

  /**
   * Obtener un Comprobante de Retención IVA por ID
   * @param {string} comprobante_id
   * @returns {Promise<Object>}
   */
  export const getRetencionIVA = async (comprobante_id) => {
    try {
      const authData = localStorage.getItem("authData");
      if (!authData) return;

      const response = await api.get(`/api/documents/retencion-iva/${comprobante_id}`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener el comprobante IVA:", error);
      throw error;
    }
  };

  export const getRetencionISLR = async (comprobante_id) => {
    try {
      const authData = localStorage.getItem("authData");
      if (!authData) return;

      const response = await api.get(`/api/documents/retencion-islr/${comprobante_id}`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener el comprobante ISLR:", error);
      throw error;
    }
  };